var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTbAppIconPrimaryUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M9 12a3.5 3.5 0 1 0-3.5-3.5A3.5 3.5 0 0 0 9 12m0-5a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 9 7m.05 10H4.77A10.4 10.4 0 0 1 9 16c.11 0 .23.01.34.01a4.6 4.6 0 0 1 1.64-1.81A12 12 0 0 0 9 14c-2.34 0-7 1.17-7 3.5V19h7v-1.5a2.7 2.7 0 0 1 .05-.5m7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3m1.21-1.82a2.5 2.5 0 1 0-2.42 0 2.45 2.45 0 0 0 2.42 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconPrimaryUser);
export default __webpack_public_path__ + "static/media/tb_app_icon_primary_user.410f598eb1713416ab44a8ae00a06c70.svg";
export { ForwardRef as ReactComponent };